import Api from "./base/api-base";

export default class DepartmentApi {
    //部署マスタ一覧取得
    list() {
        return Api.get({
            endpoint: Api.endpoint.department,
        });
    }

    //部署マスタ登録
    store(params) {
        return Api.post({
            endpoint: Api.endpoint.department,
            params: params
        });
    }

    //部署マスタ情報取得
    info(id) {
        return Api.get({
            endpoint: Api.endpoint.department,
            id: id,
        });
    }

    //部署マスタ更新
    update(id, params) {
        return Api.post({
            endpoint: Api.endpoint.department,
            id: id,
            params: params
        });
    }

    //部署マスタ削除
    delete(id) {
        return Api.delete({
            endpoint: Api.endpoint.department,
            id: id
        });
    }
}